<template>



<div class="container">
	<div class="ribbon"><span>PREVIEW</span></div>
	<div class="panel">	

		<div class="row">
			<div class="columns">
				<LogoUpload />
			</div>
		</div>

		<div class="row">
			<div class="columns">
				<ThemePreview />
			</div>
		</div>
	</div>
		


	<div v-if="!hasCustomSkin">
		<div class="panel" id="themes">	

		<h4>Choose a theme</h4>

		<div v-if="!loadingTheme">		
			<ul class="medium-block-grid-2"  id="theme-grid">

				<li v-for="theme in themes" class="text-center" style="padding: 0.6rem">
					<input type="radio" :value="theme.skinKey" v-model="selectedTheme" :id="theme.skinKey" style="display: none">
					<label :for="theme.skinKey" name="themes">						
						<span v-for="colour in theme.colours" style="display: inline-block; width: 30px; height: 30px;" :style="{background: '#' + colour}"></span>
					</label>


					<div v-if="selectedTheme == theme.skinKey">
						<i class="fa fa-check-circle text-info" aria-hidden="true"></i>
					</div>

					<div v-else>
						&nbsp;
					</div>
				</li>
			</ul>
		</div>


		<div v-else class="loading">
			<i class="fal fa-circle-notch fa-spin fa-3x fa-fw text-info"></i>
		</div>

	</div>

	
	</div>
	<div v-else>
		<h2>It looks like you have a custom theme</h2>
         <p>To change your current theme please contact us on support.</p>
	</div>

	
</div>

</template>


<script>
'use strict';
import { mapGetters } from 'vuex';
import ThemePreview from './ThemePreview';
import LogoUpload from './LogoUpload';
import CustomSkinMessage from './CustomSkinMessage';

const STATUS_INITIAL = 0,
	STATUS_SAVING = 1,
	STATUS_SUCCESS = 2,
	STATUS_FAILED = 3;

export default {
	name: 'Theme',
	data() {
		return {
			loading: true,
			uploadedFiles: [],
			uploadError: null,
			currentStatus: null,
			uploadFieldName: 'logo',
			isSaving: false,
			loadingTheme: false
		};
	},

	methods: {},

	computed: {
		...mapGetters(['logoUrl', 'themes', 'hasCustomSkin']),

		selectedTheme: {
			get() {
				return this.$store.getters.selectedTheme;
			},
			async set(value) {
				this.loadingTheme = true;
				await this.$store.dispatch('UPDATE_THEME', value);
				this.loadingTheme = false;
			}
		}
	},

	components: {
		ThemePreview,
		LogoUpload,
		CustomSkinMessage
	},

	beforeMount() {
		// this.setting = this.$root.$el.dataset.settingName;
		// this.label = this.$root.$el.dataset.settingLabel;
	},

	mounted() {},
	created() {}
};
</script>



<style scoped>
[v-cloak] {
	display: none;
}

.container {
	display: grid;
	grid-template-columns: 6fr 2fr;
	grid-auto-rows: 1fr;
	grid-column-gap: 16px;
	position: relative;
}

#themes {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr 7fr;
}

#themes .loading {
	align-items: center;
	margin: 0 auto;
}

.loading {
	display: grid;
	align-items: center;
}

#theme-grid li {
	display: grid;
	grid-template-columns: 1fr 16px;
	align-items: center;
}

label {
	margin: 0 auto !important;
}

.selected {
	border: 1px solid #083850 !important;
}
</style>
